$(function() {
  $('[data-toggle="tooltip"]').tooltip();
  $('[data-toggle="popover"]').popover();
});


window.load_contents_id = function(slug_id, slug)
{
  $.ajax(
  {
    url: "/courses/get_contents",
    data: {slug: slug}
  }).done(
    function(html_from_server) 
    {
      $(slug_id).html(html_from_server);
    }
  );
};

window.load_contents = function(slug)
{
  $.ajax(
  {
    url: "/courses/get_contents",
    data: {slug: slug}
  }).done(
    function(html_from_server) 
    {

      html_from_server += "<script>show_mainContent();</script>";
      $('#inner-right').html(html_from_server);
  $('img[data-zoomable]').addClass('img-zoomable').click(function(){
    var src = $(this).attr('src');
    var modal;
    function removeModal(){ modal.remove(); $('body').off('keyup.modal-close'); }
    modal = $('<div>').css({
        background: 'RGBA(0,0,0,1.0) url('+src+') no-repeat center',
        backgroundSize: 'contain',
        width:'100%', height:'100%',
        position:'fixed',
        zIndex:'10000',
        top:'0', left:'0',
        cursor: 'zoom-out'
    }).click(function(){
        removeModal();
    }).appendTo('body');
    //handling ESC
    $('body').on('keyup.modal-close', function(e){
      if(e.key==='Escape'){ removeModal(); } 
    });
  });




      
    }
  );
};